export default __webpack_public_path__ + "eecedb3f7af7d7d526893e30539d400c.png";